export default __webpack_public_path__ + "static/media/whatsapp-icon.36ee7021.svg";